var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharityEnvironment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.995 1003.52c271.457 0 491.52-220.063 491.52-491.521s-220.063-491.52-491.52-491.52c-271.459 0-491.52 220.061-491.52 491.52s220.061 491.521 491.52 491.521zM163.74 390.803c22.956-65.974 64.131-123.419 117.499-166.309 16.459 25.136 44.869 41.74 77.157 41.74 50.898 0 92.16 41.261 92.16 92.16v30.72c0 67.865 55.015 122.88 122.879 122.88 67.866 0 122.88-55.015 122.88-122.88 0-57.761 39.854-106.214 93.563-119.361 56.52 64.783 90.757 149.514 90.757 242.242 0 20.936-1.746 41.467-5.1 61.45h-56.34c-67.866 0-122.88 55.014-122.88 122.88v134.994c-54.221 31.365-117.181 49.316-184.325 49.316v-122.875c0-67.866-55.015-122.88-122.88-122.88s-122.88-55.014-122.88-122.881c0-60.918-44.329-111.483-102.49-121.196z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharityEnvironment);
export default __webpack_public_path__ + "static/media/charity-environment.b49cfefff2aa97277a360c0f4d726c90.svg";
export { ForwardRef as ReactComponent };